module.exports = __webpack_public_path__ + "img/kickball.a8e27aa5.gif";